import React from 'react';

import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ListItemButton } from '@mui/material';

type ExpandableListItemProps = {
  open: boolean;
  icon: React.ReactNode;
  primaryLabel: React.ReactNode;
  secondaryLabel?: React.ReactNode;
  children: React.ReactNode;
};

export const ExpandableListItem = (props: ExpandableListItemProps) => {
  const [expanded, setExpanded] = React.useState(!!props.open);
  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <>
      <ListItemButton onClick={toggleExpanded}>
        {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
        <ListItemText
          primary={props.primaryLabel}
          secondary={props.secondaryLabel}
        />
        <ExpandMoreIcon
          color="action"
          sx={{
            transform: `rotate(${expanded ? '180' : '0'}deg)`,
            transition: 'transform 300ms',
          }}
        />
      </ListItemButton>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List disablePadding sx={{ '& > *': { pl: 4 } }}>
          {props.children}
        </List>
      </Collapse>
    </>
  );
};

export default ExpandableListItem;
